import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import { Switch } from "@fluentui/react-components";

import { useDeviceInfo } from "../../../hooks/use-device-info.js";
import { useLayoutStore } from "../../../store/layout.store.js";

export const SettingsUserLayout = () => {
  const chatOpenByDefault = useLayoutStore((state) => state.chatOpenByDefault);
  const setChatOpenByDefault = useLayoutStore(
    (state) => state.setChatOpenByDefault
  );
  const setUseSimplifiedOffice = useLayoutStore(
    (state) => state.setUseSimplifiedOffice
  );
  const useSimplifiedOfficePreference = useLayoutStore(
    (state) => state.useSimplifiedOfficePreference
  );
  const { isMobile } = useDeviceInfo();
  const useSimplifiedOffice = useSimplifiedOfficePreference ?? isMobile;
  const handleChatVisibleChange = useStableCallback((_, data) =>
    setChatOpenByDefault(data.checked)
  );
  const handleUseSimplifiedOfficeChange = useStableCallback((_, data) =>
    setUseSimplifiedOffice(data.checked)
  );

  return (
    <ul className="flex w-full flex-col space-y-6">
      <li className="flex items-center">
        <span className="text-sm font-medium">Open Chat by default</span>
        <Switch
          checked={chatOpenByDefault}
          className="ml-auto"
          onChange={handleChatVisibleChange}
        />
      </li>
      <li className="flex items-center">
        <span className="text-sm font-medium">Use simplified office</span>
        <Switch
          checked={useSimplifiedOffice}
          className="ml-auto"
          onChange={handleUseSimplifiedOfficeChange}
        />
      </li>
    </ul>
  );
};
